// Mapping for AiEnhancementModal text to listFor
export const LIST_FOR_MAP = {
  'Email Content': 'email',
  'Message Content': 'message',
  'Text Content': 'text',
  'Experiences Content': 'experience',
  'Marketing Post Content': 'marketing',
  'Marketing Email Content': 'marketing',
  'Resources Content': 'resources'
};
export const AI_TAGS = {
  MAKE_IT_SHORTER: "Make it shorter",
  MAKE_IT_LONGER: "Make it longer",
  JUST_FIX_GRAMMAR: "Just fix grammar",
  MAKE_IT_MORE_CASUAL: "Make it more casual",
  MAKE_IT_MORE_PROFESSIONAL: "Make it more professional",
  MAKE_IT_PERSUASIVE: "Make it persuasive",
  MAKE_IT_FRIENDLY: "Make it more friendly"
};
